module.exports = __webpack_public_path__ + "img/grid.35b5dee4.svg";